import { z } from 'zod';

export const jobRefreshSchoolsDataResult = z.object({
  ok: z.boolean(),
  message: z.string(),
});
export type JobRefreshSchoolsDataResult = z.infer<typeof jobRefreshSchoolsDataResult>;
